// Map from cart contents to the richer model used for editing
// We may be restoring from an old kit that is no longer valid in the current catalog (for reordering old
// kits), so we only overwrite the default state with data we've validated against the catalog.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { encoderAmplifierCatalogFor } from "../secondary-if/SecondaryIfCatalog";
import { defaultAmpState } from "../rna-fish/EditKitForm";
import { ampKitToAmpFormState } from "../rna-fish/RnaFishKitToFormState";
import { defaultBuffersComponentState, defaultEncoderComponentState, } from "./EditKitForm";
export var encoderKitToFormState = function (catalog, kit, admin, kitPrice) {
    var _a;
    // Resolve the encoder's species (if any) up front so both the encoder and amplifier components
    // use the amplifier catalog for that species.
    var encoderComponent = kit.encoderComponent;
    var encoderSpecies = encoderComponent
        ? catalog.encoder.primarySpecies.find(function (p) { return p.id === encoderComponent.encodeA.id; })
        : undefined;
    var encoderAmpCatalog = encoderAmplifierCatalogFor(catalog, encoderSpecies);
    var encoderEnabled = false;
    var encoderState = defaultEncoderComponentState(catalog);
    var ampEnabled = false;
    var ampState = defaultAmpState(encoderAmpCatalog);
    if (encoderComponent !== undefined) {
        encoderEnabled = true;
        if (encoderSpecies !== undefined) {
            encoderState = __assign(__assign({}, encoderState), { primarySpecies: encoderSpecies });
        }
        var amp = encoderAmpCatalog.channels.find(function (a) { return a.hcrAmplifier.id === encoderComponent.hcrAmplifier.id; });
        if (amp !== undefined) {
            encoderState = __assign(__assign({}, encoderState), { hcrAmplifier: amp.hcrAmplifier });
            ampState = __assign(__assign({}, ampState), { hcrAmplifier: amp.hcrAmplifier, label: amp.defaultLabel.label, scale: amp.defaultLabel.defaultScale });
        }
        var scale = catalog.encoder.scales.find(function (s) { return s.slides === encoderComponent.scale.slides; });
        if (scale !== undefined) {
            encoderState = __assign(__assign({}, encoderState), { scale: scale });
        }
        if (kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.encoderPriceCustom) {
            encoderState = __assign(__assign({}, encoderState), { customPrice: {
                    listPriceCents: 0,
                    effectivePriceCents: kitPrice.encoderPriceCents
                } });
        }
    }
    if (kit.amplifierComponent !== undefined) {
        var ampComponent = kit.amplifierComponent;
        ampEnabled = true;
        ampState = ampKitToAmpFormState(ampState, ampComponent, encoderAmpCatalog, admin);
        if (!encoderComponent) {
            encoderState = __assign(__assign({}, encoderState), { hcrAmplifier: ampState.hcrAmplifier });
        }
        if ((kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.amplifierPriceCustom) === true) {
            ampState = __assign(__assign({}, ampState), { customPrice: {
                    listPriceCents: 0,
                    effectivePriceCents: kitPrice.amplifierPriceCents,
                } });
        }
    }
    var buffersEnabled = false;
    var buffersState = defaultBuffersComponentState(catalog);
    var buffersComponent = kit.buffersComponent;
    if (buffersComponent !== undefined) {
        buffersEnabled = true;
        if ((kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.buffersPriceCustom) === true) {
            buffersState = __assign(__assign({}, buffersState), { customPrice: {
                    listPriceCents: 0,
                    effectivePriceCents: kitPrice.buffersPriceCents,
                } });
        }
        buffersState = __assign(__assign({}, buffersState), { antibody: buffersComponent.antibodyBuffer, antibodyWash: buffersComponent.antibodyWashBuffer, amplification: buffersComponent.amplificationBuffer, goldAmpWash: buffersComponent.ampWashBuffer });
    }
    var sampleTypeFormState = {
        sampleType: (_a = catalog.buffer.sampleTypes.find(function (t) { return t.id === kit.sampleType.id; })) !== null && _a !== void 0 ? _a : catalog.buffer.defaultSampleType
    };
    return {
        encoderComponentEnabled: encoderEnabled,
        encoderComponentState: encoderState,
        ampEnabled: ampEnabled,
        ampState: ampState,
        buffersEnabled: buffersEnabled,
        buffersState: buffersState,
        sampleTypeFormState: sampleTypeFormState,
        comment: kit.comment,
        price: undefined,
        priceLoading: false,
        errors: []
    };
};
//# sourceMappingURL=ManualGoldIfKitToFormState.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/manual-gold-if/ManualGoldIfKitToFormState.js
// module id = 328
// module chunks = 0